export const OZON_PRIZE_TEXT = 'Сертификат Ozon на сумму';

export const WINNER_LIST_ANCHOR = 'winner-list-anchor';
